import './styles.scss';

export default {
    name: 'ShapeModeDropdown',
    
    data() {
        return  {
            lineThickness: '5',
            primaryColor: '#FF0000',
            shape: 'square'
        };
    },

    methods: {
        chooseColor(color) {
            this.primaryColor = color;

            this.$ionic.popoverController.dismiss({ 
                lineThickness: this.lineThickness,
                primaryColor: this.primaryColor,
                shape: this.shape
            });
        },
        
        chooseLineThickness(thickness) {
            this.lineThickness = thickness;

            this.$ionic.popoverController.dismiss({ 
                lineThickness: this.lineThickness,
                primaryColor: this.primaryColor,
                shape: this.shape
            });
        },

        chooseShape(shape) {
            this.shape = shape;

            this.$ionic.popoverController.dismiss({ 
                lineThickness: this.lineThickness,
                primaryColor: this.primaryColor,
                shape: this.shape
            });
        }
    }
};